module.exports = __webpack_public_path__ + "img/pin_yellow.bae5a635.svg";